<template>
  <th 
    class="py-2 px-4 border-b text-left cursor-pointer hover:bg-gray-50" 
    :class="additionalClasses"
    @click="handleSort"
  >
    <div class="flex items-center">
      {{ title }}
      <span class="ml-1">
        <svg 
          v-if="isCurrentSortField" 
          class="w-4 h-4" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path :d="sortDirection === 'asc' ? svgPaths.arrowDown : svgPaths.arrowUp"/>
        </svg>
        <svg 
          v-else 
          class="w-4 h-4 text-gray-300" 
          fill="currentColor" 
          viewBox="0 0 20 20"
        >
          <path :d="svgPaths.arrowDown"/>
        </svg>
      </span>
    </div>
  </th>
</template>

<script>
export default {
  name: 'SortableTableHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    currentSortField: {
      type: String,
      default: ''
    },
    sortDirection: {
      type: String,
      default: 'asc',
      validator: (value) => ['asc', 'desc'].includes(value)
    },
    additionalClasses: {
      type: String,
      default: ''
    },
    isDefault: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      svgPaths: {
        arrowUp: 'M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z',
        arrowDown: 'M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z'
      }
    };
  },
  computed: {
    isCurrentSortField() {
      return this.currentSortField === this.field || (this.isDefault && !this.currentSortField);
    }
  },
  methods: {
    handleSort() {
      this.$emit('sort', this.field);
    }
  },
  emits: ['sort']
};
</script>